import card1 from '@assets/images/card1.jpeg'
import card2 from '@assets/images/card2.jpeg'
import card3 from '@assets/images/card3.jpeg'
import styles from './StatsCards.module.css'

const stats = [
  {
    id: 1,
    number: '14+',
    title: 'Years',
    subtitle: 'of Work Expertise',
    description: "Our team combines extensive knowledge with hands-on experience. We're committed to excellence in every installation, repair, and maintenance service.",
    image: card1,
    variant: 'light1',
  },
  {
    id: 2,
    number: '80+',
    title: '',
    subtitle: 'Team of Experts',
    description: 'With diverse expertise in HVAC systems, we ensure every project is handled with the highest standards of quality and precision.',
    image: card2,
    variant: 'light2',
  },
  {
    id: 3,
    number: '350+',
    title: '',
    subtitle: 'Projects Completed',
    description: 'Our Track Record speaks for itself. We have delivered top-notch HVAC solutions to various sectors, showcasing our ability to handle diverse challenges with excellence.',
    image: card3,
    variant: 'dark',
  },
]

const StatsCards = () => {
  return (
    <section className={styles.statsCards}>
      <div className={styles.cardsWrapper}>
        {stats.map((stat, index) => (
          <div
            key={stat.id}
            className={`${styles.cardContainer} ${styles[`card${index + 1}`]}`}
            style={{ '--card-index': index }}
          >
            <div className={`${styles.card} ${styles[stat.variant]}`}>
              <div className={styles.iconWrapper}>
                <img src={stat.image} alt={stat.subtitle} className={styles.cardImage} />
              </div>
              <div className={styles.content}>
                <h3 className={styles.number}>
                  {stat.number} {stat.title && <span>{stat.title}</span>}
                </h3>
                <p className={styles.subtitle}>{stat.subtitle}</p>
                <p className={styles.description}>{stat.description}</p>
              </div>
            </div>
          </div>
        ))}
        <div className={styles.scrollSpacer} />
      </div>
    </section>
  )
}

export default StatsCards
